$bog_merchquarium_gallery $mol_view
	sub <= items /$mol_view
